/*
 * IE10 has a bug whereby a required select field will fail validation if the user selects the 1st option in the 1st optgroup, the 2nd option in the 2nd optgroup, 3rd in the 3rd and so on...
 * Bug report: (closed as not reproducible!)
 * https://connect.microsoft.com/IE/feedback/details/786442/ie-10-html5-form-validation-select-boxes
 * Demo:
 * http://jsfiddle.net/J3wFx/
 * Workaround:
 * http://sampsonblog.com/473/ie10-gotcha-optgroup-indexes-and-the-required-attribute
 */
(function($)
{
    $.fn.ieselectfix = function()
    {
        return this.each(function() {
            if($.browser.msie && parseFloat($.browser.version) == 10.0) {
                $(this).find('select[required] optgroup').attr('value', '0');
            }
        });
    };
})(jQuery);